export const SAGAS_CONSTANTS = {
	STATUS: {
		IDLE: 'idle',
		SUCCESS: 'success',
		FAILURE: 'failure',
		LOADING: 'loading',
	},
}
